<div class="__project-chip" [class.is-changed]="hasChanged()">
  <div class="__project-info">
    <span class="__project-name">{{ projectName() }}</span>

    <div>
      @for (tag of tags(); track tag) {
        <zui-tag class="__tag">{{ tag }}</zui-tag>
      }
    </div>
  </div>

  <div
    class="__role"
    [class.__role--full]="roleVariant() === 'full'"
    [class.__role--basic]="roleVariant() === 'basic'"
    [class.__role--read]="roleVariant() === 'read'"
    [class.__role--none]="roleVariant() === 'none'">
    <mat-icon class="__role-icon" fontSet="material-icons-outlined">{{ roleIcon() }}</mat-icon>
    <span class="__role-label">{{ roleLabel() }}</span>
  </div>

  @if (menuActions().length > 0) {
    <button
      mat-icon-button
      type="button"
      class="__menu-trigger"
      #menuRef="dynamicPopAnchor"
      (click)="menuRef.open()"
      [zuiDynamicPopAnchor]="menuPopover()">
      <mat-icon>more_vert</mat-icon>
    </button>
  }
</div>

@if (menuActions().length > 0) {
  <sat-popover
    #menuPopover
    hasBackdrop
    [backdropClass]="'cdk-overlay-transparent-backdrop'"
    xAlign="after"
    yAlign="start">
    <mat-card class="__menu-card z-manual-elevation c-soft-elevation">
      <mat-action-list>
        @for (action of menuActions(); track action.type) {
          <button
            mat-list-item
            type="button"
            class="__menu-item"
            (click)="menuAction.emit(action); menuPopover.close()">
            @if (action.icon) {
              <mat-icon matListItemIcon fontSet="material-icons-outlined">{{ action.icon }}</mat-icon>
            }
            <span matListItemTitle>{{ action.label }}</span>
          </button>
        }
      </mat-action-list>
    </mat-card>
  </sat-popover>
}
